import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactezUnExpert from "./sections/ContactezUnExpert";
import OurOffices from "./sections/OurOffices";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactezUnExpert />
      <OurOffices />
      <Footer />
    </div>;
}